export const TOSHI_OS_ADD_POINTS_LOGS = 'toshi_os_add_points_logs'
